import React from "react";

export const WarehousingDetailContext = React.createContext(null);

export const useWarehousingDetailContext = () => {
    const context = React.useContext(WarehousingDetailContext);

    if (!context) throw new Error("warehousing Detail Context not provided!");

    return context;
};